module.exports = __webpack_public_path__ + "img/contest-logo-hu.8ba54856.png";